import { PageContainer } from "@volca/ui/components/ui/page-components";
import {
  SimpleSidebarContent,
  SimpleSidebarLayout,
} from "@volca/ui/components/ui/simple-sidebar";
import { PackChatSectionProvider } from "@/payroll/pack-chat/pack-chat-section";
import { PacksSectionProvider } from "@/payroll/pay-breakdown/payroll-statement-notifications/packs-section";
import { StAdjustmentsSectionProvider } from "@/payroll/pay-breakdown/st-adjustments";
import { PAY_BREAKDOWN_SECTION } from "@/payroll/pay-breakdown/types";
import { PayBreakdownDialogs } from "./pay-breakdown-dialogs";
import { PayBreakdownExplanationAside } from "./pay-breakdown-explanation-aside";
import { PayBreakdownGridSection } from "./pay-breakdown-grid-section";
import { PayBreakdownPageHeader } from "./pay-breakdown-page-header";
import { PayBreakdownSectionPanels } from "./pay-breakdown-section-panels";
import { PayBreakdownSidebar } from "./pay-breakdown-sidebar";
import { usePayBreakdownPage } from "./use-pay-breakdown-page";

export const PayBreakdownPage = () => {
  const page = usePayBreakdownPage();
  const {
    businessId,
    selectedPeriodStart,
    aiScriptRunId,
    payrollEmailsAccess,
    stAdjustmentsAccess,
    activeSection,
    isWorkspacePage,
    rosterVersionNumber,
    currentRosterVersionNumber,
    packChatOpenByTechnician,
    setSelectedJob,
    setSectionSidebarOpen,
    sectionSidebarCloseRef,
    setIsExplanationChatOpen,
    setIsCommentsOpen,
    closeManualEdits,
    setIsNotesOpen,
    isSidebarOpen,
  } = page;

  return (
    <PackChatSectionProvider>
      {/* Idled off-tab by a null period: every query underneath is gated on
          business and period, so this can stay mounted — which it must, or the
          Grid remounts on every tab switch. */}
      <PacksSectionProvider
        businessId={businessId}
        periodStart={
          activeSection === PAY_BREAKDOWN_SECTION.packs
            ? (selectedPeriodStart ?? null)
            : null
        }
        payrollEmailsAccess={payrollEmailsAccess}
        awaitingReplyTechnicianIds={packChatOpenByTechnician}
      >
        {/* The real run stays attached off-tab so an active push can finish its
            status watch. `enabled` idles only the view data until PushPay returns. */}
        <StAdjustmentsSectionProvider
          businessId={businessId}
          access={stAdjustmentsAccess}
          runId={aiScriptRunId}
          enabled={activeSection === PAY_BREAKDOWN_SECTION.adjustments}
          rosterVersionNumber={
            rosterVersionNumber ?? currentRosterVersionNumber
          }
        >
          <SimpleSidebarLayout
            open={isSidebarOpen}
            onOpenChange={(open) => {
              if (open) return;
              sectionSidebarCloseRef.current?.();
              setSectionSidebarOpen(false);
              setSelectedJob(null);
              setIsExplanationChatOpen(false);
              setIsCommentsOpen(false);
              closeManualEdits();
              setIsNotesOpen(false);
            }}
          >
            {/* The content scrolls natively rather than in a ScrollArea, and the
                same way on every tab: swapping the wrapper per tab would remount
                everything under it, the Grid included. */}
            <SimpleSidebarContent removeScrollArea className="overflow-y-auto">
              <PageContainer
                variant={isWorkspacePage ? "workspace" : "document"}
                className="min-w-0 contain-[inline-size]"
              >
                <PayBreakdownPageHeader page={page} />

                <PayBreakdownGridSection page={page} />

                <PayBreakdownSectionPanels page={page} />
              </PageContainer>
            </SimpleSidebarContent>

            <PayBreakdownSidebar page={page} />
            <PayBreakdownExplanationAside page={page} />

            <PayBreakdownDialogs page={page} />
          </SimpleSidebarLayout>
        </StAdjustmentsSectionProvider>
      </PacksSectionProvider>
    </PackChatSectionProvider>
  );
};
